import * as React from 'react';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { NavRail } from './NavRail';

// Sprint 38 — Mobile / phone-breakpoint nav drawer.
// Uses the shadcn Sheet primitive (already retheme'd to 2px ink border,
// no shadow, sharp corners). Same NavRail content as the desktop rail.

interface MobileDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onOpenFeedback?: () => void;
  brand?: React.ReactNode;
  accessVersion?: number;
}

export function MobileDrawer({ open, onOpenChange, onOpenFeedback, brand, accessVersion = 0 }: MobileDrawerProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="left"
        className="flex h-full w-72 max-w-[85vw] flex-col overflow-hidden p-0 sm:max-w-sm"
      >
        <NavRail
          brand={brand}
          accessVersion={accessVersion}
          onOpenFeedback={() => {
            onOpenChange(false);
            onOpenFeedback?.();
          }}
          onItemSelect={() => onOpenChange(false)}
        />
      </SheetContent>
    </Sheet>
  );
}
